namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd9Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd9';
    }
}
